import { ComponentType } from 'react';

import { Element, Processor } from '@/features/html2react/types';

import Spacer from '../components/spacer';

interface SpacerElement extends Element {
  props: Element['props'];
}

const spacer: Processor<SpacerElement> = {
  priority: 10,
  name: 'script',
  test: ({ node }) => !!node.props?.className && node.props.className.includes('wp-block-erom-spacer'),
  processor: ({ node }) => {
    node.component = Spacer as ComponentType;
    return node;
  }
};

export default spacer;
